module.exports = __webpack_public_path__ + "static/media/loading-text.ba6d476e.svg";